import React from 'react';

export const ELITE_PACKAGE_SLUG = 'elite';

/*
 * Features/features groups/resources names.
 * These values MUST match the names defined in the backend.
 */
export const PLATINUM_ONLY_DESIGNERS = 'Platinum-only Designers';
export const PLATINUM_ONLY_CREATIVES = 'Platinum-only Creatives';
export const UNLIMITED_COLLABORATION = 'Team Collaboration';
export const NDAS = 'NDAs';
export const SEARCH_EXCLUSION = 'Search Exclusion';
export const PRIVATE_PROJECT = 'Private Project';
export const PRIVACY_BUNDLE = 'Privacy Bundle';
export const AWARD_ASSURED = 'Assure Your Award';
export const UNLIMITED_PRESENTATIONS = 'Unlimited Presentations';
export const UNLIMITED_FOCUS_GROUPS = 'Unlimited Focus Groups';
export const ONE_FOCUS_GROUP = 'One Focus Group';
export const PERSONAL_CONSULTANT = 'Personal Project Consultant';
export const DURATION_GROUP = 'LENGTH';
export const PROMOTION_GROUP = 'PROMOTION';
export const NDAS_MANUAL_APPROVAL = 'NDAS_MANUAL_APPROVAL';

/*
 * LEGACY features/features groups names.
 * These values MUST match the names defined in the backend.
 */
export const LEGACY_PLATINUM_ONLY_DESIGNERS = 'Platinum creatives only';
export const LEGACY_UNLIMITED_COLLABORATION = 'Collaboration features';
export const LEGACY_NDAS = 'NDA';
export const LEGACY_SEARCH_EXCLUSION = 'Search exclusion';
export const LEGACY_PRIVATE_GALLERY = 'Blind project';
export const LEGACY_AWARD_ASSURED = 'Assured project';
export const LEGACY_DURATION = 'Length';
export const LEGACY_STARTER_PROMOTION = 'Starter promotion';
export const LEGACY_BASIC_PROMOTION = 'Basic promotion';
export const LEGACY_ADVANCED_PROMOTION = 'Advanced promotion';
export const LEGACY_ULTIMATE_PROMOTION = 'Ultimate promotion';
export const LEGACY_TWITTER_PROMOTION = 'Twitter promotion';

export const PACKAGE_SELECTOR_DESCRIPTIONS = {
  silver: <span>For individuals<br className="show-for-large"/> and new small businesses</span>,
  gold: <span>Perfect for startups<br className="show-for-large"/> and growing businesses</span>,
  elite: <span>Great for businesses,<br className="show-for-large"/> agencies & marketers</span>,
  platinum: <span>All-inclusive for businesses,<br className="show-for-large"/> agencies & marketers</span>
};

const FEATURE_CONCEPTS = {
  includedInPackages: ['silver', 'gold', 'elite', 'platinum'],
  optionalInPackages: [],
  name: {
    'default': 'Designs (approximately)',
    bySubcat: {
      'business-tagline': 'Taglines (approximately)',
      'naming-a-business-or-product': 'Names (approximately)'
    }
  },
  includedLabels: {
    byPackage: {
      silver: {
        'default': '40',
        bySubcat: {
          'blog-theme-design': '40',
          'book-cover-design': '40',
          'brochure-or-menu-design': '40',
          'business-card-design': '40',
          'business-tagline': '100',
          'email-design': '30',
          'icon-button-and-widget-design': '40',
          'infographics-design': '25',
          'illustration-and-graphic-design': '40',
          'landing-page-design': '25',
          'letterhead-and-stationery-design': '40',
          'logo-design': '60',
          'logo-and-business-card-design': '60',
          'logo-and-social-media-assets-design': '60',
          'magazine-cover-design': '40',
          'merchandise-design': '40',
          'mobile-ui-design': '30',
          'naming-a-business-or-product': '100',
          'other-clothing-design': '40',
          'outdoor-or-signage-design': '40',
          'packaging-design': '40',
          'package-graphics': '40',
          'postcard-or-flyer-design': '40',
          'poster-design': '40',
          'presentation-design': '40',
          'product-design': '30',
          'social-media-assets-design': '40',
          't-shirt-design': '50',
          'tattoo-design': '40',
          'vehicle-wrap-design': '40',
          'wall-mural-art-design': '40',
          'web-banner-design': '40',
          'website-design': '25'
        }
      },
      gold: {
        'default': '50',
        bySubcat: {
          'blog-theme-design': '50',
          'book-cover-design': '70',
          'brochure-or-menu-design': '50',
          'business-card-design': '60',
          'business-tagline': '130',
          'email-design': '40',
          'icon-button-and-widget-design': '50',
          'infographics-design': '30',
          'illustration-and-graphic-design': '50',
          'landing-page-design': '35',
          'letterhead-and-stationery-design': '60',
          'logo-design': '90',
          'logo-and-business-card-design': '75',
          'logo-and-social-media-assets-design': '75',
          'magazine-cover-design': '50',
          'merchandise-design': '50',
          'mobile-ui-design': '40',
          'naming-a-business-or-product': '130',
          'other-clothing-design': '50',
          'outdoor-or-signage-design': '50',
          'packaging-design': '50',
          'package-graphics': '50',
          'postcard-or-flyer-design': '50',
          'poster-design': '50',
          'presentation-design': '50',
          'product-design': '40',
          'social-media-assets-design': '50',
          't-shirt-design': '70',
          'tattoo-design': '50',
          'vehicle-wrap-design': '50',
          'wall-mural-art-design': '50',
          'web-banner-design': '50',
          'website-design': '35'
        }
      },
      elite: {
        'default': '20 Elite',
        bySubcat: {
          'blog-theme-design': '20 Elite',
          'book-cover-design': '20 Elite',
          'brochure-or-menu-design': '20 Elite',
          'business-card-design': '20 Elite',
          'email-design': '20 Elite',
          'icon-button-and-widget-design': '20 Elite',
          'infographics-design': '20 Elite',
          'illustration-and-graphic-design': '20 Elite',
          'landing-page-design': '20 Elite',
          'letterhead-and-stationery-design': '20 Elite',
          'logo-design': '20 Elite',
          'logo-and-business-card-design': '20 Elite',
          'logo-and-social-media-assets-design': '20 Elite',
          'magazine-cover-design': '20 Elite',
          'merchandise-design': '20 Elite',
          'mobile-ui-design': '20 Elite',
          'other-clothing-design': '20 Elite',
          'outdoor-or-signage-design': '20 Elite',
          'packaging-design': '20 Elite',
          'package-graphics': '20 Elite',
          'postcard-or-flyer-design': '20 Elite',
          'poster-design': '20 Elite',
          'presentation-design': '20 Elite',
          'product-design': '20 Elite',
          'social-media-assets-design': '20 Elite',
          't-shirt-design': '20 Elite',
          'tattoo-design': '20 Elite',
          'vehicle-wrap-design': '20 Elite',
          'wall-mural-art-design': '20 Elite',
          'web-banner-design': '20 Elite',
          'website-design': '20 Elite'
        }
      },
      platinum: {
        'default': '50 Premium',
        bySubcat: {
          'blog-theme-design': '40 Premium',
          'book-cover-design': '70 Premium',
          'brochure-or-menu-design': '50 Premium',
          'business-card-design': '50 Premium',
          'business-tagline': '100 Premium',
          'email-design': '50 Premium',
          'icon-button-and-widget-design': '50 Premium',
          'infographics-design': '30 Premium',
          'illustration-and-graphic-design': '50 Premium',
          'landing-page-design': '30 Premium',
          'letterhead-and-stationery-design': '50 Premium',
          'logo-design': '75 Premium',
          'logo-and-business-card-design': '75 Premium',
          'logo-and-social-media-assets-design': '75 Premium',
          'magazine-cover-design': '50 Premium',
          'merchandise-design': '50 Premium',
          'mobile-ui-design': '50 Premium',
          'naming-a-business-or-product': '100 Premium',
          'other-clothing-design': '50 Premium',
          'outdoor-or-signage-design': '50 Premium',
          'packaging-design': '50 Premium',
          'package-graphics': '50 Premium',
          'postcard-or-flyer-design': '40 Premium',
          'poster-design': '50 Premium',
          'presentation-design': '50 Premium',
          'product-design': '40 Premium',
          'social-media-assets-design': '50 Premium',
          't-shirt-design': '60 Premium',
          'tattoo-design': '50 Premium',
          'vehicle-wrap-design': '50 Premium',
          'wall-mural-art-design': '50 Premium',
          'web-banner-design': '40 Premium',
          'website-design': '30 Premium'
        }
      },
    }
  },
  details: {
    name: {
      byPackage: {
        silver: {
          'default': 'Approximately 40 designs',
          bySubcat: {
            'blog-theme-design': 'Approximately 40 designs',
            'book-cover-design': 'Approximately 40 designs',
            'brochure-or-menu-design': 'Approximately 40 designs',
            'business-card-design': 'Approximately 40 designs',
            'business-tagline': 'Approximately 100 taglines',
            'email-design': 'Approximately 40 designs',
            'icon-button-and-widget-design': 'Approximately 40 designs',
            'infographics-design': 'Approximately 25 designs',
            'illustration-and-graphic-design': 'Approximately 40 designs',
            'landing-page-design': 'Approximately 25 designs',
            'letterhead-and-stationery-design': 'Approximately 40 designs',
            'logo-design': 'Approximately 60 designs',
            'logo-and-business-card-design': 'Approximately 60 designs',
            'logo-and-social-media-assets-design': 'Approximately 60 designs',
            'magazine-cover-design': 'Approximately 40 designs',
            'merchandise-design': 'Approximately 40 designs',
            'mobile-ui-design': 'Approximately 30 designs',
            'naming-a-business-or-product': 'Approximately 100 names',
            'other-clothing-design': 'Approximately 40 designs',
            'outdoor-or-signage-design': 'Approximately 40 designs',
            'packaging-design': 'Approximately 40 designs',
            'package-graphics': 'Approximately 40 designs',
            'postcard-or-flyer-design': 'Approximately 40 designs',
            'poster-design': 'Approximately 40 designs',
            'presentation-design': 'Approximately 40 designs',
            'product-design': 'Approximately 30 designs',
            'social-media-assets-design': 'Approximately 40 designs',
            't-shirt-design': 'Approximately 50 designs',
            'tattoo-design': 'Approximately 40 designs',
            'vehicle-wrap-design': 'Approximately 40 designs',
            'wall-mural-art-design': 'Approximately 40 designs',
            'web-banner-design': 'Approximately 40 designs',
            'website-design': 'Approximately 25 designs'
          }
        },
        gold: {
          'default': 'Approximately 50 designs',
          bySubcat: {
            'blog-theme-design': 'Approximately 50 designs',
            'book-cover-design': 'Approximately 70 designs',
            'brochure-or-menu-design': 'Approximately 50 designs',
            'business-card-design': 'Approximately 60 designs',
            'business-tagline': 'Approximately 130 taglines',
            'email-design': 'Approximately 40 designs',
            'icon-button-and-widget-design': 'Approximately 50 designs',
            'infographics-design': 'Approximately 30 designs',
            'illustration-and-graphic-design': 'Approximately 50 designs',
            'landing-page-design': 'Approximately 35 designs',
            'letterhead-and-stationery-design': 'Approximately 60 designs',
            'logo-design': 'Approximately 90 designs',
            'logo-and-business-card-design': 'Approximately 75 designs',
            'logo-and-social-media-assets-design': 'Approximately 75 designs',
            'magazine-cover-design': 'Approximately 50 designs',
            'merchandise-design': 'Approximately 50 designs',
            'mobile-ui-design': 'Approximately 40 designs',
            'naming-a-business-or-product': 'Approximately 130 names',
            'other-clothing-design': 'Approximately 50 designs',
            'outdoor-or-signage-design': 'Approximately 50 designs',
            'packaging-design': 'Approximately 50 designs',
            'package-graphics': 'Approximately 50 designs',
            'postcard-or-flyer-design': 'Approximately 50 designs',
            'poster-design': 'Approximately 50 designs',
            'presentation-design': 'Approximately 50 designs',
            'product-design': 'Approximately 40 designs',
            'social-media-assets-design': 'Approximately 50 designs',
            't-shirt-design': 'Approximately 70 designs',
            'tattoo-design': 'Approximately 50 designs',
            'vehicle-wrap-design': 'Approximately 50 designs',
            'wall-mural-art-design': 'Approximately 50 designs',
            'web-banner-design': 'Approximately 50 designs',
            'website-design': 'Approximately 35 designs'
          }
        },
        elite: {
          'default': 'Approximately 20 elite designs',
          bySubcat: {
            'blog-theme-design': 'Approximately 20 elite designs',
            'book-cover-design': 'Approximately 20 elite designs',
            'brochure-or-menu-design': 'Approximately 20 elite designs',
            'business-card-design': 'Approximately 20 elite designs',
            'email-design': 'Approximately 20 elite designs',
            'icon-button-and-widget-design': 'Approximately 20 elite designs',
            'infographics-design': 'Approximately 20 elite designs',
            'illustration-and-graphic-design': 'Approximately 20 elite designs',
            'landing-page-design': 'Approximately 20 elite designs',
            'letterhead-and-stationery-design': 'Approximately 20 elite designs',
            'logo-design': 'Approximately 20 elite designs',
            'logo-and-business-card-design': 'Approximately 20 elite designs',
            'logo-and-social-media-assets-design': 'Approximately 20 elite designs',
            'magazine-cover-design': 'Approximately 20 elite designs',
            'merchandise-design': 'Approximately 20 elite designs',
            'mobile-ui-design': 'Approximately 20 elite designs',
            'other-clothing-design': 'Approximately 20 elite designs',
            'outdoor-or-signage-design': 'Approximately 20 elite designs',
            'packaging-design': 'Approximately 20 elite designs',
            'package-graphics': 'Approximately 20 elite designs',
            'postcard-or-flyer-design': 'Approximately 20 elite designs',
            'poster-design': 'Approximately 20 elite designs',
            'presentation-design': 'Approximately 20 elite designs',
            'product-design': 'Approximately 20 elite designs',
            'social-media-assets-design': 'Approximately 20 elite designs',
            't-shirt-design': 'Approximately 20 elite designs',
            'tattoo-design': 'Approximately 20 elite designs',
            'vehicle-wrap-design': 'Approximately 20 elite designs',
            'wall-mural-art-design': 'Approximately 20 elite designs',
            'web-banner-design': 'Approximately 20 elite designs',
            'website-design': 'Approximately 20 elite designs'
          }
        },
        platinum: {
          'default': 'Approximately 50 premium designs',
          bySubcat: {
            'blog-theme-design': 'Approximately 40 premium designs',
            'book-cover-design': 'Approximately 70 premium designs',
            'brochure-or-menu-design': 'Approximately 50 premium designs',
            'business-card-design': 'Approximately 50 premium designs',
            'business-tagline': 'Approximately 100 premium taglines',
            'email-design': 'Approximately 50 premium designs',
            'icon-button-and-widget-design': 'Approximately 50 premium designs',
            'infographics-design': 'Approximately 30 premium designs',
            'illustration-and-graphic-design': 'Approximately 50 premium designs',
            'landing-page-design': 'Approximately 30 premium designs',
            'letterhead-and-stationery-design': 'Approximately 50 premium designs',
            'logo-design': 'Approximately 75 premium designs',
            'logo-and-business-card-design': 'Approximately 75 premium designs',
            'logo-and-social-media-assets-design': 'Approximately 75 premium designs',
            'magazine-cover-design': 'Approximately 50 premium designs',
            'merchandise-design': 'Approximately 50 premium designs',
            'mobile-ui-design': 'Approximately 50 premium designs',
            'naming-a-business-or-product': 'Approximately 100 premium names',
            'other-clothing-design': 'Approximately 50 premium designs',
            'outdoor-or-signage-design': 'Approximately 50 premium designs',
            'packaging-design': 'Approximately 50 premium designs',
            'package-graphics': 'Approximately 50 premium designs',
            'postcard-or-flyer-design': 'Approximately 40 premium designs',
            'poster-design': 'Approximately 50 premium designs',
            'presentation-design': 'Approximately 50 premium designs',
            'product-design': 'Approximately 40 premium designs',
            'social-media-assets-design': 'Approximately 50 premium designs',
            't-shirt-design': 'Approximately 60 premium designs',
            'tattoo-design': 'Approximately 50 premium designs',
            'vehicle-wrap-design': 'Approximately 50 premium designs',
            'wall-mural-art-design': 'Approximately 50 premium designs',
            'web-banner-design': 'Approximately 40 premium designs',
            'website-design': 'Approximately 30 premium designs'
          }
        }
      }
    },
    description: {
      'default': "The number of design concepts varies from project to project. Projects with more interesting and engaging titles, well-written project briefs, and active clients tend to receive more entries.",
      byPackage: {
        'silver': {
          bySubcat: {
            'naming-a-business-or-product': "The number of name suggestions varies from project to project. Projects with more interesting and engaging titles, well-written project briefs, and active clients tend to receive more name suggestions.",
            'business-tagline': "The number of tagline suggestions varies from project to project. Projects with more interesting and engaging titles, well-written project briefs, and active clients tend to receive more tagline suggestions."
          },
        },
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "The number of name suggestions varies from project to project. Projects with more interesting and engaging titles, well-written project briefs, and active clients tend to receive more name suggestions.",
            'business-tagline': "The number of tagline suggestions varies from project to project. Projects with more interesting and engaging titles, well-written project briefs, and active clients tend to receive more tagline suggestions."
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "The number of name suggestions varies from project to project. Projects with more interesting and engaging titles, well-written project briefs, and active clients tend to receive more name suggestions.",
            'business-tagline': "The number of tagline suggestions varies from project to project. Projects with more interesting and engaging titles, well-written project briefs, and active clients tend to receive more tagline suggestions."
          }
        }
      }
    },
    question: {
      'default': "How can you get more designs?",
      byPackage: {
        'silver': {
          bySubcat: {
            'naming-a-business-or-product': "How can you get more names?",
            'business-tagline': "How can you get more taglines?"
          }
        },
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "How can you get more names?",
            'business-tagline': "How can you get more taglines?"
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "How can you get more names?",
            'business-tagline': "How can you get more taglines?"
          }
        }
      }
    },
    answer: {
      'default': "Your level of participation directly impacts the number of designs you will receive. The more you score and comment on the submitted designs, the more design concepts you’ll receive. Clients who are actively scoring and commenting regularly see 2 to 3 times more design concepts compared to other clients.",
      byPackage: {
        'silver': {
          bySubcat: {
            'naming-a-business-or-product': "Your level of participation directly impacts the number of name suggestions you will receive. The more you score and comment on the submitted names, the more name suggestions you’ll receive. Clients who are actively scoring and commenting regularly see 2 to 3 times more name suggestions concepts compared to other clients.",
            'business-tagline': "Your level of participation directly impacts the number of tagline suggestions you will receive. The more you score and comment on the submitted taglines, the more tagline suggestions you’ll receive. Clients who are actively scoring and commenting regularly see 2 to 3 times more tagline suggestions concepts compared to other clients."
          }
        },
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "Your level of participation directly impacts the number of name suggestions you will receive. The more you score and comment on the submitted names, the more name suggestions you’ll receive. Clients who are actively scoring and commenting regularly see 2 to 3 times more name suggestions concepts compared to other clients.",
            'business-tagline': "Your level of participation directly impacts the number of tagline suggestions you will receive. The more you score and comment on the submitted taglines, the more tagline suggestions you’ll receive. Clients who are actively scoring and commenting regularly see 2 to 3 times more tagline suggestions concepts compared to other clients."
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "Your level of participation directly impacts the number of name suggestions you will receive. The more you score and comment on the submitted names, the more name suggestions you’ll receive. Clients who are actively scoring and commenting regularly see 2 to 3 times more name suggestions concepts compared to other clients.",
            'business-tagline': "Your level of participation directly impacts the number of tagline suggestions you will receive. The more you score and comment on the submitted taglines, the more tagline suggestions you’ll receive. Clients who are actively scoring and commenting regularly see 2 to 3 times more tagline suggestions concepts compared to other clients."
          }
        }
      }
    }
  }
};

const FEATURE_OWNERSHIP = {
  includedInPackages: ['silver', 'gold', 'elite', 'platinum'],
  optionalInPackages: [],
  name: {
    'default': 'Full copyright ownership',
  },
  details: {
    description: {
      'default': "Every package includes a customized legal agreement giving you full copyright to the winning design. If you have multiple awards, you'll receive full copyright ownership to each awarded design.",
      byPackage: {
        'silver': {
          bySubcat: {
            'naming-a-business-or-product': "Every package includes a customized legal agreement giving you full copyright to the winning name. If you have multiple awards, you'll receive full copyright ownership to each awarded name.",
            'business-tagline': "Every package includes a customized legal agreement giving you full copyright to the winning tagline. If you have multiple awards, you'll receive full copyright ownership to each awarded tagline."
          }
        },
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "Every package includes a customized legal agreement giving you full copyright to the winning name. If you have multiple awards, you'll receive full copyright ownership to each awarded name.",
            'business-tagline': "Every package includes a customized legal agreement giving you full copyright to the winning tagline. If you have multiple awards, you'll receive full copyright ownership to each awarded tagline."
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "Every package includes a customized legal agreement giving you full copyright to the winning name. If you have multiple awards, you'll receive full copyright ownership to each awarded name.",
            'business-tagline': "Every package includes a customized legal agreement giving you full copyright to the winning tagline. If you have multiple awards, you'll receive full copyright ownership to each awarded tagline."
          }
        },
      }
    },
    question: {
      'default': "Can you buy more designs?",
      byPackage: {
        'silver': {
          bySubcat: {
            'naming-a-business-or-product': "Can you buy more names?",
            'business-tagline': "Can you buy more taglines?"
          }
        },
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "Can you buy more names?",
            'business-tagline': "Can you buy more taglines?"
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "Can you buy more names?",
            'business-tagline': "Can you buy more taglines?"
          }
        }
      }
    },
    answer: {
      'default': "We give you an easy way to add awards in your projects even after the project is posted, so that you can award multiple designers and buy multiple different designs. And if you want to purchase more than one design, you can always make an offer instead of adding another award.",
      byPackage: {
        'silver': {
          bySubcat: {
            'naming-a-business-or-product': "We give you an easy way to add awards in your projects even after the project is posted, so that you can award multiple namers and buy multiple different names. And if you want to purchase more than one name, you can always make an offer instead of adding another award.",
            'business-tagline': "We give you an easy way to add awards in your projects even after the project is posted, so that you can award multiple creatives and buy multiple different taglines. And if you want to purchase more than one tagline, you can always make an offer instead of adding another award."
          }
        },
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "We give you an easy way to add awards in your projects even after the project is posted, so that you can award multiple namers and buy multiple different names. And if you want to purchase more than one name, you can always make an offer instead of adding another award.",
            'business-tagline': "We give you an easy way to add awards in your projects even after the project is posted, so that you can award multiple creatives and buy multiple different taglines. And if you want to purchase more than one tagline, you can always make an offer instead of adding another award."
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "We give you an easy way to add awards in your projects even after the project is posted, so that you can award multiple namers and buy multiple different names. And if you want to purchase more than one name, you can always make an offer instead of adding another award.",
            'business-tagline': "We give you an easy way to add awards in your projects even after the project is posted, so that you can award multiple creatives and buy multiple different taglines. And if you want to purchase more than one tagline, you can always make an offer instead of adding another award."
          }
        },
      }
    }
  }
};

const FEATURE_GUARANTEE = {
  includedInPackages: ['silver', 'gold', 'elite', 'platinum'],
  optionalInPackages: [],
  name: {
    'default': '100% guarantee',
  },
  includedLabels: {
    byPackage: {
      elite: {
        'default': 'Assured award + tips',
      }
    }
  },
  details: {
    description: {
      'default': "We hate confusing refund policies, so ours is simple. In silver, gold and platinum design projects: if you're not 100% happy with your design project, contact us within 30 days and we'll refund what you paid. In elite projects, because you want to work with our very best designers and incentivize them to do their best work, you assure that the participants will be paid.",
      byPackage: {
        'silver': {
          bySubcat: {
            'naming-a-business-or-product': "We hate confusing refund policies, so ours is simple: if your naming project doesn't receive at least 100 entries, contact us within 30 days and we'll refund what you paid.",
            'business-tagline': "We hate confusing refund policies, so ours is simple: if your tagline project doesn't receive at least 100 entries, contact us within 30 days and we'll refund what you paid.",
          }
        },
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "We hate confusing refund policies, so ours is simple: if your naming project doesn't receive at least 100 entries, contact us within 30 days and we'll refund what you paid.",
            'business-tagline': "We hate confusing refund policies, so ours is simple: if your tagline project doesn't receive at least 100 entries, contact us within 30 days and we'll refund what you paid.",
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "We hate confusing refund policies, so ours is simple: if your naming project doesn't receive at least 100 entries, contact us within 30 days and we'll refund what you paid.",
            'business-tagline': "We hate confusing refund policies, so ours is simple: if your tagline project doesn't receive at least 100 entries, contact us within 30 days and we'll refund what you paid.",
          }
        }
      }
    },
    question: {
      'default': "Why does crowdspring offer a guarantee?"
    },
    answer: {
      'default': "We have one of the most talented communities of designers on the planet. Over the past decade, our team has helped tens of thousands of small business owners, entrepreneurs, agencies, and non-profits. The vast majority of our clients find a great design they love. But we know that sometimes, you just won't find something you love. It's rare, but it happens. That's why we offer your a simple promise: you'll find something you love, or your money back.",
      byPackage: {
        'silver': {
          bySubcat: {
            'naming-a-business-or-product': "We have one of the most talented communities of creatives on the planet. Over the past decade, our team has helped tens of thousands of small business owners, entrepreneurs, agencies, and non-profits. The vast majority of our clients find a great name they love. But we know that sometimes, you just won't find something you love. It's rare, but it happens. That's why we offer your a simple promise: you'll find something you love, or your money back.",
            'business-tagline': "We have one of the most talented communities of creatives on the planet. Over the past decade, our team has helped tens of thousands of small business owners, entrepreneurs, agencies, and non-profits. The vast majority of our clients find a great tagline they love. But we know that sometimes, you just won't find something you love. It's rare, but it happens. That's why we offer your a simple promise: you'll find something you love, or your money back."
          }
        },
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "We have one of the most talented communities of creatives on the planet. Over the past decade, our team has helped tens of thousands of small business owners, entrepreneurs, agencies, and non-profits. The vast majority of our clients find a great name they love. But we know that sometimes, you just won't find something you love. It's rare, but it happens. That's why we offer your a simple promise: you'll find something you love, or your money back.",
            'business-tagline': "We have one of the most talented communities of creatives on the planet. Over the past decade, our team has helped tens of thousands of small business owners, entrepreneurs, agencies, and non-profits. The vast majority of our clients find a great tagline they love. But we know that sometimes, you just won't find something you love. It's rare, but it happens. That's why we offer your a simple promise: you'll find something you love, or your money back."
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "We have one of the most talented communities of creatives on the planet. Over the past decade, our team has helped tens of thousands of small business owners, entrepreneurs, agencies, and non-profits. The vast majority of our clients find a great name they love. But we know that sometimes, you just won't find something you love. It's rare, but it happens. That's why we offer your a simple promise: you'll find something you love, or your money back.",
            'business-tagline': "We have one of the most talented communities of creatives on the planet. Over the past decade, our team has helped tens of thousands of small business owners, entrepreneurs, agencies, and non-profits. The vast majority of our clients find a great tagline they love. But we know that sometimes, you just won't find something you love. It's rare, but it happens. That's why we offer your a simple promise: you'll find something you love, or your money back."
          }
        },
      }
    }
  }
};

const FEATURE_UNLIMITED_ENTRIES = {
  includedInPackages: ['silver', 'gold', 'elite', 'platinum'],
  optionalInPackages: [],
  name: {
    'default': 'Unlimited designs',
    bySubcat: {
      'naming-a-business-or-product': 'Unlimited names',
      'business-tagline': 'Unlimited taglines'
    }
  }
};

const FEATURE_UNLIMITED_CREATIVES = {
  includedInPackages: ['silver', 'gold', 'elite', 'platinum'],
  optionalInPackages: [],
  name: {
    'default': 'Unlimited designers',
    bySubcat: {
      'naming-a-business-or-product': 'Unlimited namers',
      'business-tagline': 'Unlimited creatives'
    }
  },
  includedLabels: {
    byPackage: {
      elite: {
        'default': '5 Elite designers',
      }
    }
  },
};

const FEATURE_PROMOTION = {
  includedInPackages: ['gold', 'elite', 'platinum'],
  optionalInPackages: ['silver'],
  tooltipContent: {
    'default': 'A promotion gives your project more exposure and attracts our best creatives.'
  },
  name: {
    'default': 'Promotion',
  },
  details: {
    description: {
      'default': "Give your project more exposure and attract our best creatives.",
      byPackage: {
        'gold': {
          'default': "Basic promotion gives you a highlighted listing on our Explore page to give your project more visibility; you'll get an average of 25% more designs and 27% more designers.",
          bySubcat: {
            'naming-a-business-or-product': "Basic promotion gives you a highlighted listing on our Explore page to give your project more visibility; you'll get an average of 25% more names and 27% more namers.",
            'business-tagline': "Basic promotion gives you a highlighted listing on our Explore page to give your project more visibility; you'll get an average of 25% more taglines and 27% more creatives.",
          }
        },
        'elite': {
          'default': "We'll promote your project to our best designers and you'll work with five elite designers (reputation of 90 to 100) in your project."
        },
        'platinum': {
          'default': "Advanced promotion includes everything in our Basic promotion package (a highlighted listing on our Explore page to give your project more visibility and an average of 25% more designs and 27% more designers), plus your project is showcased in our Featured Projects email sent to 100,000+ designers and we automatically invite the top designers to participate in your project; you can get 80% more designs and 70% more participants.",
          bySubcat: {
            'naming-a-business-or-product': "Advanced promotion includes everything in our Basic promotion package (a highlighted listing on our Explore page to give your project more visibility and an average of 25% more names and 27% more namers), plus your project is showcased in our Featured Projects email sent to 100,000+ namers and we automatically invite the top namers to participate in your project; you can get 80% more names and 70% more participants.",
            'business-tagline': "Advanced promotion includes everything in our Basic promotion package (a highlighted listing on our Explore page to give your project more visibility and an average of 25% more taglines and 27% more creatives), plus your project is showcased in our Featured Projects email sent to 100,000+ creatives and we automatically invite the top creatives to participate in your project; you can get 80% more taglines and 70% more participants.",
          }
        },
      }
    },
    question: {
      'default': "What promotions are available?",
      byPackage: {
        'gold': {
          'default': "What other promotions are available?"
        },
        'elite': {
          'default': "What other promotions are available?"
        },
        'platinum': {
          'default': "What other promotions are available?"
        }
      }
    },
    answer: {
      'default': `<div>
        <ul>
          <li><i class="fa fa-check"></i><span class="content">Basic promotion gives you a highlighted listing on our Explore page to give your project more visibility; you'll get an average of 25% more designs and 27% more designers.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Advanced promotion includes everything in our Basic promotion package, plus your project is showcased in our Featured Projects email sent to 100,000+ designers and we automatically invite the top designers to participate in your project; you can get 80% more designs and 70% more participants.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Elite promotion is available only in Elite packages. We'll promote your project to our best designers and you'll work with five elite designers (reputation of 90  to 100) in your project.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Our Starter Promotion lets you announce your project with a tweet from @crowdspring, helping you reach thousands of creatives. Our Ultimate promotion includes everything in Basic, Starter, and Advanced promotion packages and you save 18% by bundling everything together.</span></li>
        </ul>
    </div>`,
      byPackage: {
        'silver': {
          bySubcat: {
            'naming-a-business-or-product': `<div>
        <ul>
          <li><i class="fa fa-check"></i><span class="content">Basic promotion gives you a highlighted listing on our Explore page to give your project more visibility; you'll get an average of 25% more names and 27% more namers.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Advanced promotion includes everything in our Basic promotion package, plus your project is showcased in our Featured Projects email sent to 100,000+ namers and we automatically invite the top namers to participate in your project; you can get 80% more names and 70% more participants.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Our Starter Promotion lets you announce your project with a tweet from @crowdspring, helping you reach thousands of creatives. Our Ultimate promotion includes everything in Basic, Starter, and Advanced promotion packages and you save 18% by bundling everything together.</span></li>
        </ul>
    </div>`,
            'business-tagline': `<div>
        <ul>
          <li><i class="fa fa-check"></i><span class="content">Basic promotion gives you a highlighted listing on our Explore page to give your project more visibility; you'll get an average of 25% more taglines and 27% more creatives.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Advanced promotion includes everything in our Basic promotion package, plus your project is showcased in our Featured Projects email sent to 100,000+ creatives and we automatically invite the top creatives to participate in your project; you can get 80% more taglines and 70% more participants.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Our Starter Promotion lets you announce your project with a tweet from @crowdspring, helping you reach thousands of creatives. Our Ultimate promotion includes everything in Basic, Starter, and Advanced promotion packages and you save 18% by bundling everything together.</span></li>
        </ul>
    </div>`
          }
        },
        'gold': {
          'default': `<div>
        <ul>
          <li><i class="fa fa-check"></i><span class="content">Advanced promotion includes everything in our Basic promotion package, plus your project is showcased in our Featured Projects email sent to 100,000+ designers and we automatically invite the top designers to participate in your project; you can get 80% more designs and 70% more participants.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Our Ultimate promotion includes everything in Basic, Starter, and Advanced promotion packages and you save 18% by bundling everything together.</span></li>
        </ul>
    </div>`,
          bySubcat: {
            'naming-a-business-or-product': `<div>
        <ul>
          <li><i class="fa fa-check"></i><span class="content">Advanced promotion includes everything in our Basic promotion package, plus your project is showcased in our Featured Projects email sent to 100,000+ namers and we automatically invite the top namers to participate in your project; you can get 80% more names and 70% more participants.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Our Ultimate promotion includes everything in Basic, Starter, and Advanced promotion packages and you save 18% by bundling everything together.</span></li>
        </ul>
    </div>`,
            'business-tagline': `<div>
        <ul>
          <li><i class="fa fa-check"></i><span class="content">Advanced promotion includes everything in our Basic promotion package, plus your project is showcased in our Featured Projects email sent to 100,000+ creatives and we automatically invite the top creatives to participate in your project; you can get 80% more taglines and 70% more participants.</span></li>
          <li><i class="fa fa-check"></i><span class="content">Our Ultimate promotion includes everything in Basic, Starter, and Advanced promotion packages and you save 18% by bundling everything together.</span></li>
        </ul>
    </div>`,
          },
        },
        'elite': {
          'default': "In an Elite project, you'll work with 5 of our best designers. No other promotions are available."
        },
        'platinum': {
          'default': 'Our Ultimate promotion includes everything in Basic, Starter (Twitter), and Advanced promotion packages and you save 18% by bundling everything together.'
        }
      }
    }
  }
};

const FEATURE_PRIVACY = {
  includedInPackages: ['elite', 'platinum'],
  optionalInPackages: ['silver', 'gold'],
  tooltipContent: {
    'default': 'Need more privacy? You can exclude your project from search engines, close your project gallery so that only you and the participant who submitted a design can see it, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.',
    bySubcat: {
      'naming-a-business-or-product': 'Need more privacy? You can exclude your project from search engines, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.',
      'business-tagline': 'Need more privacy? You can exclude your project from search engines, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.'
    }
  },
  name: {
    'default': 'Project privacy',
  },
  details: {
    description: {
      'default': "You can add valuable privacy features to your project. For example, you can exclude your project from search engines, close your project gallery so that only you and the participant who submitted a design can see it, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.",
      byPackage: {
        silver: {
          bySubcat: {
            'naming-a-business-or-product': "You can add valuable privacy features to your project. For example, you can exclude your project from search engines, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.",
            'business-tagline': "You can add valuable privacy features to your project. For example, you can exclude your project from search engines, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.",
          }
        },
        gold: {
          bySubcat: {
            'naming-a-business-or-product': "You can add valuable privacy features to your project. For example, you can exclude your project from search engines, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.",
            'business-tagline': "You can add valuable privacy features to your project. For example, you can exclude your project from search engines, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.",
          }
        },
        platinum: {
          bySubcat: {
            'naming-a-business-or-product': "You can add valuable privacy features to your project. For example, you can exclude your project from search engines, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.",
            'business-tagline': "You can add valuable privacy features to your project. For example, you can exclude your project from search engines, require non-disclosure (NDA) agreements, and create a public/private project brief, letting everyone see the public brief but allowing only people you approve to see your private project brief.",
          }
        },
      }
    },
    question: {
      'default': "Why should you consider hiding your gallery?",
      byPackage: {
        silver: {
          bySubcat: {
            'naming-a-business-or-product': "Why should you keep your project private?",
            'business-tagline': "Why should you keep your project private?",
          }
        },
        gold: {
          bySubcat: {
            'naming-a-business-or-product': "Why should you keep your project private?",
            'business-tagline': "Why should you keep your project private?",
          }
        },
        platinum: {
          bySubcat: {
            'naming-a-business-or-product': "Why should you keep your project private?",
            'business-tagline': "Why should you keep your project private?",
          }
        },
      }
    },
    answer: {
      'default': "<p>In design projects on crowdspring, the gallery is visible to everyone. This works great for most clients. If privacy is not a major concern for your project, revealing the gallery creates a more collaborative design process.</p><p>Some clients want a little more privacy and security. Hidden galleries provide added security for your project. When a gallery is hidden, the client is the only person who can see all of the entries. Participating creatives can only see their own entries. In projects with collaborators, you can also allow collaborators you invite and approve to see all entries.</p><p>Hidden galleries are included in Elite and Platinum projects at no additional cost. They can also be purchased as a separate upgrade in Silver and Gold projects. In naming projects, galleries are always private, in all packages.</p>",
      byPackage: {
        silver: {
          bySubcat: {
            'naming-a-business-or-product': "Galleries in naming projects are always hidden. For more privacy, non-disclosure agreements and private briefs help you to hide your project from competitors and prying eyes.",
            'business-tagline': "Galleries in tagline projects are always hidden. For more privacy, non-disclosure agreements and private briefs help you to hide your project from competitors and prying eyes.",
          }
        },
        gold: {
          bySubcat: {
            'naming-a-business-or-product': "Galleries in naming projects are always hidden. For more privacy, non-disclosure agreements and private briefs help you to hide your project from competitors and prying eyes.",
            'business-tagline': "Galleries in tagline projects are always hidden. For more privacy, non-disclosure agreements and private briefs help you to hide your project from competitors and prying eyes.",
          }
        },
        platinum: {
          bySubcat: {
            'naming-a-business-or-product': "Galleries in naming projects are always hidden. For more privacy, non-disclosure agreements and private briefs help you to hide your project from competitors and prying eyes.",
            'business-tagline': "Galleries in tagline projects are always hidden. For more privacy, non-disclosure agreements and private briefs help you to hide your project from competitors and prying eyes.",
          }
        },
      }
    }
  }
};

const FEATURE_PLATINUM_CREATIVES = {
  includedInPackages: ['elite', 'platinum'],
  optionalInPackages: ['gold'],
  tooltipContent: {
    'default': 'Work only with our top level designers (a reputation of 80 to 100). Receive premium designs and pick your favorite design from among more creative designs.',
    bySubcat: {
      'naming-a-business-or-product': 'Work only with our top level namers (a reputation of 80 to 100). Receive premium names and pick your favorite name from among more creative name suggestions.',
      'business-tagline': 'Work only with our top level creatives (a reputation of 80 to 100). Receive premium taglines and pick your favorite tagline from among more creative tagline suggestions.'
    }
  },
  name: {
    'default': 'Only top level designers',
    bySubcat: {
      'naming-a-business-or-product': 'Only top level namers',
      'business-tagline': 'Only top level creatives',
    }
  },
  includedLabels: {
    byPackage: {
      elite: {
        'default': 'Elite designers only',
      },
      platinum: {
        'default': <span>Platinum + Elite <span className="hide-for-small-only">designers</span></span>,
        bySubcat: {
          'naming-a-business-or-product': 'Platinum namers only',
          'business-tagline': 'Platinum creatives only'
        }
      }
    }
  },
  details: {
    description: {
      'default': "In Platinum projects, you will work only with our top level designers (a reputation of 80 to 100). This upgrade can also be purchased in Gold projects ($199) but is not available in Silver projects. In Elite projects, you will work with 5 of our best designers.",
      byPackage: {
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "In Platinum projects, you work only with our top level namers (a reputation of 80 to 100). This upgrade can also be purchased in Gold projects ($199) but is not available in Silver projects.",
            'business-tagline': "In Platinum projects, you work only with our top level creatives (a reputation of 80 to 100). This upgrade can also be purchased in Gold projects ($199) but is not available in Silver projects."
          }
        },
        'elite': {
          'default': 'In Elite projects, you will work with 5 of our best designers.'
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "In Platinum projects, you work only with our top level namers (a reputation of 80 to 100). This upgrade can also be purchased in Gold projects ($199) but is not available in Silver projects.",
            'business-tagline': "In Platinum projects, you work only with our top level creatives (a reputation of 80 to 100). This upgrade can also be purchased in Gold projects ($199) but is not available in Silver projects."
          }
        }
      }
    },
    question: {
      'default': "Why work with only our top designers?",
      byPackage: {
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "Why work with Platinum-only namers?",
            'business-tagline': "Why work with Platinum-only creatives?"
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "Why work with Platinum-only namers?",
            'business-tagline': "Why work with Platinum-only creatives?"
          }
        },
      }
    },
    answer: {
      'default': "When you work with our top level designers, you'll receive premium designs and pick your favorite design from among more creative designs.",
      byPackage: {
        'gold': {
          bySubcat: {
            'naming-a-business-or-product': "When you work with our top level namers, you'll receive premium name suggestions and pick your favorite name from among more creative names.",
            'business-tagline': "When you work with our top level creatives, you'll receive premium tagline suggestions and pick your favorite tagline from among more creative taglines."
          }
        },
        'platinum': {
          bySubcat: {
            'naming-a-business-or-product': "When you work with our top level namers, you'll receive premium name suggestions and pick your favorite name from among more creative names.",
            'business-tagline': "When you work with our top level creatives, you'll receive premium tagline suggestions and pick your favorite tagline from among more creative taglines."
          }
        },
      }
    }
  }
};

const FEATURE_MANAGER = {
  includedInPackages: ['elite', 'platinum'],
  optionalInPackages: [],
  tooltipContent: {
    'default': 'One of our experienced project support managers will work with you to make sure your Elite or Platinum project succeeds.'
  },
  name: {
    'default': 'Dedicated manager',
  },
  details: {
    description: {
      'default': "One of our experienced project support managers will work with you to make sure your Elite or Platinum project succeeds."
    },
    question: {
      'default': "What other support is available?"
    },
    answer: {
      'default': "Our entire support team will be available to help you. Our support team is among the best in the world (we have many awards to prove this). We provide email, phone, and chat support 7 days per week."
    }
  }
};

const FEATURE_SUPPORT = {
  includedInPackages: ['elite', 'platinum'],
  optionalInPackages: [],
  tooltipContent: {
    'default': 'Elite and Platinum projects receive priority support from our customer support team. We answer most questions within one hour.'
  },
  name: {
    'default': <span>Priority <span className="hide-for-small-only">customer</span> support</span>,
  },
  details: {
    description: {
      'default': "Elite and Platinum projects receive priority support from our customer support team. We answer most questions within one hour."
    },
    question: {
      'default': "Will you get support in Silver and Gold projects?"
    },
    answer: {
      'default': "Absolutely! Our support team is among the best in the world (we have many awards to prove this). We provide email, phone, and chat support 7 days per week."
    }
  }
};

const FEATURE_COLLABORATION = {
  includedInPackages: ['platinum'],
  optionalInPackages: ['elite', 'gold'],
  tooltipContent: {
    'default': 'Working with another person, a team, or your client? Choose this option to invite others to help you manage your project.'
  },
  name: {
    'default': 'Team collaboration',
  },
  details: {
    description: {
      'default': "Working with another person, a team, or your client? Choose this option to invite others to help you manage your project. Invite creatives, score entries, and give feedback. One fee covers unlimited collaborators. A powerful tool for consultants and teams working together. Collaboration is included in all Platinum projects and is available as an upgrade in Gold and Elite projects ($99). Collaboration is not offered in Silver projects."
    },
    question: {
      'default': "Can each collaborator have unique permissions?"
    },
    answer: {
      'default': "Absolutely! You decide what each collaborator can see and do in your project and every project you post can have different collaborators, with unique permissions."
    }
  }
};

const FEATURE_PRESENTATIONS = {
  includedInPackages: ['platinum'],
  optionalInPackages: ['elite', 'gold'],
  tooltipContent: {
    'default': 'A presentation is a great way for agencies, art directors, project managers and consultants to discreetly share entries in your project with clients and others. Choose your favorite entries and display them in a custom-branded (you can upload your own logo), online gallery. The gallery is private, password protected, and you control who is permitted to view that gallery. You can even launch multiple presentation pages.'
  },
  name: {
    'default': 'Unlimited presentations',
  },
  details: {
    description: {
      'default': "A presentation is a great way for agencies, art directors, project managers and consultants to discreetly share designs in your project with clients and others. Choose your favorite designs and display them in a custom-branded (you can upload your own logo), online gallery. The gallery is private, password protected, and you control who is permitted to view that gallery. You can even launch multiple presentation pages."
    },
    question: {
      'default': "How do presentations and focus groups differ?"
    },
    answer: {
      'default': "<p>Focus Groups are designed to to let you invite many people to vote on their favorite designs from your project. You can include people you know, and even people you don't know personally (such as Twitter followers or customers), to help you pick a design in your project. You'll have a public link to your focus group and people won't need to log-in to participate. Focus groups are hosted on crowdspring's website.</p><p>Presentations, on the other hand, are designed for you to share designs privately with your clients and others. There is no public link to a presentation and each person will be required to have a login and password in order to see your presentation mini-site. The mini-site is not visually affiliated with crowdspring in any way - you can add your own custom branding.</p>"
    }
  }
};

const FEATURE_UNLIMITED_FOCUS_GROUPS = {
  includedInPackages: ['silver','gold', 'elite', 'platinum'],
  optionalInPackages: [],
  tooltipContent: {
    'default': 'A focus group (also called a poll) allows you to invite friends, customers, colleagues, and anyone else to vote and comment on their favorite designs.'
  },
  name: {
    'default': 'Unlimited focus groups',
  }
};

const FEATURE_CONSULTANT = {
  includedInPackages: [],
  optionalInPackages: ['silver', 'gold'],
  tooltipContent: {
    'default': 'One of our experienced personal project consultants will work with you to make sure your Silver or Gold project succeeds.'
  },
  name: {
    'default': 'Personal project consultant',
  },
  details: {
    description: {
      'default': "One of our experienced personal project consultants will work with you to make sure your Silver or Gold project succeeds."
    },
    question: {
      'default': "What other support is available?"
    },
    answer: {
      'default': "Our entire support team will be available to help you. Our support team is among the best in the world (we have many awards to prove this). We provide email, phone, and chat support 7 days per week."
    }
  }
};


export const FEATURES_BY_SUBCAT = {
  'default': [
    FEATURE_CONCEPTS, FEATURE_OWNERSHIP, FEATURE_GUARANTEE, FEATURE_UNLIMITED_ENTRIES,
    FEATURE_UNLIMITED_CREATIVES, FEATURE_UNLIMITED_FOCUS_GROUPS,
    FEATURE_PROMOTION, FEATURE_PRIVACY, FEATURE_PLATINUM_CREATIVES, FEATURE_CONSULTANT,
    FEATURE_MANAGER, FEATURE_SUPPORT, FEATURE_COLLABORATION, FEATURE_PRESENTATIONS
  ], 'naming-a-business-or-product': [
    FEATURE_CONCEPTS, FEATURE_OWNERSHIP, FEATURE_GUARANTEE, FEATURE_UNLIMITED_ENTRIES,
    FEATURE_UNLIMITED_CREATIVES, FEATURE_PROMOTION, FEATURE_PRIVACY,
    FEATURE_PLATINUM_CREATIVES, FEATURE_CONSULTANT, FEATURE_MANAGER, FEATURE_SUPPORT,
    FEATURE_COLLABORATION
  ], 'business-tagline': [
    FEATURE_CONCEPTS, FEATURE_OWNERSHIP, FEATURE_GUARANTEE, FEATURE_UNLIMITED_ENTRIES,
    FEATURE_UNLIMITED_CREATIVES, FEATURE_PROMOTION, FEATURE_PRIVACY,
    FEATURE_PLATINUM_CREATIVES, FEATURE_CONSULTANT, FEATURE_MANAGER, FEATURE_SUPPORT,
    FEATURE_COLLABORATION
  ]
};

export const MINI_PROJECT_CAT_SLUG = 'update-existing-design';
export const MINI_PROJECT_SUBCAT_SLUG = 'update-existing-design';
export const MINI_PROJECT_SUBCAT_NAME = 'Update existing design';

export const MIN_AWARD_STEP = 5;
export const DEFAULT_MAX_AWARD = 5000;

export const AWARD_REFERENCES = {
  "1to1-logo-design": { lowMax: 150, fairMax: 250, goodMax: 500 },
  "1to1-web-banner-design": { lowMax: 125, fairMax: 200, goodMax: 300 },
  "1to1-website-design": { lowMax: 300, fairMax: 500, goodMax: 750 },
  "1to1-wall-mural-art-design": { lowMax: 150, fairMax: 250, goodMax: 500 },
  "1to1-vehicle-wrap-design": { lowMax: 150, fairMax: 250, goodMax: 500 },
  "1to1-t-shirt-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-tattoo-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-business-tagline": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-social-media-assets-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-product-design": { lowMax: 500, fairMax: 750, goodMax: 1000 },
  "1to1-presentation-design": { lowMax: 150, fairMax: 250, goodMax: 500 },
  "1to1-poster-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-postcard-or-flyer-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-packaging-design": { lowMax: 200, fairMax: 350, goodMax: 600 },
  "1to1-package-graphics": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-outdoor-or-signage-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-other-clothing-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-other": { lowMax: 150, fairMax: 250, goodMax: 500 },
  "1to1-mobile-ui-design": { lowMax: 200, fairMax: 400, goodMax: 750 },
  "1to1-merchandise-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-magazine-cover-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-logo-and-social-media-assets-design": { lowMax: 175, fairMax: 250, goodMax: 400 },
  "1to1-logo-and-business-card-design": { lowMax: 175, fairMax: 250, goodMax: 500 },
  "1to1-letterhead-and-stationery-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-landing-page-design": { lowMax: 150, fairMax: 250, goodMax: 500 },
  "1to1-infographics-design": { lowMax: 200, fairMax: 300, goodMax: 400 },
  "1to1-illustration-and-graphic-design": { lowMax: 200, fairMax: 350, goodMax: 400 },
  "1to1-icon-button-and-widget-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-email-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-naming-a-business-or-product": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-business-card-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-brochure-or-menu-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-book-cover-design": { lowMax: 150, fairMax: 250, goodMax: 400 },
  "1to1-blog-theme-design": { lowMax: 150, fairMax: 250, goodMax: 400 }
};

export const DEFAULT_AWARD_REFERENCES = { lowMax: 150, fairMax: 250, goodMax: 500 };
